import { render } from "./draftDetail.vue?vue&type=template&id=5133d652"
import script from "./draftDetail.vue?vue&type=script&lang=js"
export * from "./draftDetail.vue?vue&type=script&lang=js"

import "./draftDetail.vue?vue&type=style&index=0&id=5133d652&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__